import { AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { PictureService } from 'src/app/services/picture.service';
import { CoreData } from 'src/app/tools/core-data';
import { LoadingTask } from 'src/app/tools/loading-task';

@Component({
  selector: 'app-take-photo',
  templateUrl: './take-photo.component.html',
  styleUrls: ['./take-photo.component.scss']
})
export class TakePhotoComponent implements OnInit, AfterViewInit, OnDestroy {
  private alreadyPicked: number[] = [];
  public WEBCAM_DISPLAY_WIDTH: any = window.innerWidth - 30; // 30 padding right and left 15 in the main container app
  public WEBCAM_DISPLAY_HEIGHT: any; // = 'auto';

  WEBCAM_NEW_WIDTH: number;
  WEBCAM_NEW_HEIGHT: number;

  private isFirstBackCamInitiation = true;
  private interventionCode: string;
  private interventionType: number;
  @ViewChild('video')
  public video: ElementRef<HTMLVideoElement>;

  @ViewChild('canvas')
  public canvas: ElementRef;

  public SelectedCapture;
  isCaptured: boolean;
  stream: MediaStream;
  selectedTrack: MediaStreamTrack;
  devices: MediaDeviceInfo[] = [];
  selectedDevice: string;
  GLOBAL_WIDTH = 0;

  @Output() getPicture = new EventEmitter<WebcamImage>();
  showWebcam = true;
  isCameraExist = true;

  errors: WebcamInitError[] = [];

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  public CameraCount: number;

  constructor(
    private pictureService: PictureService,
    public coreData: CoreData,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    public loadingTask: LoadingTask) {

  }

  ngOnInit(): void {
    if (!this.route.snapshot.params.interventionCode) {
      this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
      return;
    }

    this.interventionCode = this.route.snapshot.params.interventionCode;
    this.interventionType = Number(this.route.snapshot.params['type']);

    // if (this.coreData.IsMobile) {
    // this.WEBCAM_DISPLAY_WIDTH = 720;
    // this.WEBCAM_DISPLAY_HEIGHT = 1280;
    this.WEBCAM_DISPLAY_HEIGHT = window.innerHeight - 100;
    this.WEBCAM_DISPLAY_WIDTH = window.innerWidth - 30;
    console.log(this.WEBCAM_DISPLAY_HEIGHT);
    console.log(this.WEBCAM_DISPLAY_WIDTH);
    // } else {
    //   this.WEBCAM_DISPLAY_WIDTH = 1280;
    //   this.WEBCAM_DISPLAY_HEIGHT = 960;
    // }
  }
  async ngAfterViewInit() {
    if (this.route.snapshot.params['alreadyPicked'] !== undefined) {
      this.alreadyPicked = this.route.snapshot.params['alreadyPicked'].split(',').map(x => parseInt(x, 10));
    }

    // if (!navigator.mediaDevices || (await navigator.mediaDevices.enumerateDevices()).length === 0) {
    //   return;
    // }

    // if (this.coreData.IsMobile) {
    //   this.devices = await navigator.mediaDevices.enumerateDevices();
    // }
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.isCameraExist = mediaDevices && mediaDevices.length > 0;
      });
    // this.play();
  }

  public get videoOptions(): MediaTrackConstraints {

    //you can set ideal,min,max for width and height
    const result: MediaTrackConstraints = {
      width: { min: 640, ideal: 1920 },
      height: { min: 480, ideal: 1080 },
      facingMode: { ideal: 'environment' }
    };

    return result;
  }

  getCameraCount() {

    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.CameraCount = mediaDevices && mediaDevices.length;
      });
  }
  ngOnDestroy(): void {
    // this.stop();
  }
  takeSnapshot(): void {
    this.trigger.next();
  }

  onOffWebCame() {
    this.showWebcam = !this.showWebcam;
  }

  handleInitError(error: WebcamInitError) {
    this.errors.push(error);
  }

  changeWebCame(directionOrDeviceId: boolean | string) {
    this.nextWebcam.next(directionOrDeviceId);
  }

  handleImage(webcamImage: WebcamImage) {
    this.getPicture.emit(webcamImage);
    this.showWebcam = false;
    this.pictureService.updateImage(webcamImage.imageAsDataUrl);
    this.router.navigate([ENavigationRoute.Photo, { interventionCode: this.interventionCode, type: this.interventionType}], { skipLocationChange: true});
  }

  get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

}
//   async getBackCamera() {
//     // NotificationManager.handleWarning(`${window.innerWidth}`, this.snackBar);
//     return await navigator.mediaDevices.getUserMedia({
//       video: {
//         facingMode: { exact: 'environment' },
//         resizeMode: 'none',
//         // width: { ideal: this.WEBCAM_DISPLAY_WIDTH, max: window.innerWidth - 30 },
//         // height: { ideal: this.WEBCAM_DISPLAY_HEIGHT },
//         width: { ideal: 720 },
//         height: { ideal: 1280 },
//       }
//     });
//   }

//   async play() {
//     if (this.stream) {
//       this.stop();
//     }

//     try {
//       this.loadingTask.activateLoading(); // 
//       if (this.coreData.IsMobile && this.isFirstBackCamInitiation && environment.name !== 'DEV') {
//         this.stream = await this.getBackCamera();
//         this.isFirstBackCamInitiation = false;
//       } else {
//         this.stream = await navigator.mediaDevices.getUserMedia({
//           video: {
//             resizeMode: 'none',
//             width: { ideal: 1280 },
//             height: { ideal: 720 },
//             deviceId: this.selectedDevice
//           }
//         });
//       }
//       const [track] = this.stream.getVideoTracks();
//       console.log(track.getSettings());
//       this.stream.getTracks().forEach(async (t) => {
//         this.selectedTrack = t;
//         console.log(t.getSettings());
//         await new Promise((resolve, reject) => {
//           setTimeout(() => {
//             // NotificationManager.handleWarning(`facing mode: ${facingMode}`, this.snackBar);
//             resolve(true);
//           }, 2000);
//         });
//         if (this.coreData.IsMobile) {
//           // NotificationManager.handleWarning(`Cam Width: ${this.WEBCAM_DISPLAY_WIDTH} - Height: ${this.WEBCAM_DISPLAY_HEIGHT}`, this.snackBar);
//           // this.WEBCAM_DISPLAY_WIDTH = t.getSettings().height;
//           // this.WEBCAM_DISPLAY_HEIGHT = t.getSettings().width;
//           // setTimeout(() => {
//           //   NotificationManager.handleWarning(`Cam Width: ${t.getSettings().width} - Height: ${t.getSettings().height}`, this.snackBar);
//           // }, 2000);
//         } else {
//           // this.WEBCAM_DISPLAY_WIDTH = 960;
//           // this.WEBCAM_DISPLAY_HEIGHT = 720;
//         }
//       });

//       if (this.stream) {
//         this.video.nativeElement.srcObject = this.stream;
//         this.video.nativeElement.play();
//       }
//       this.loadingTask.deactivateLoading();

//       let selectedTrack = track.getSettings();
//       // let { width, height, aspectRatio, deviceId, facingMode } = track.getSettings();
//       this.selectedDevice = selectedTrack.deviceId;

//       // Constraints are in landscape, while settings may be rotated (portrait)
//       if (selectedTrack.width < selectedTrack.height) {
//         [selectedTrack.width, selectedTrack.height] = [selectedTrack.height, selectedTrack.width];
//         selectedTrack.aspectRatio = 1 / selectedTrack.aspectRatio;
//       }
//       await track.applyConstraints({
//         resizeMode: 'crop-and-scale',
//         width: { exact: selectedTrack.width },
//         height: { exact:selectedTrack. height },
//         aspectRatio: selectedTrack.aspectRatio
//         // aspectRatio: { exact: 1 / aspectRatio },
//         // width: { exact: window.innerWidth - 30 },
//       });

//       selectedTrack = track.getSettings();
//       this.WEBCAM_NEW_WIDTH = window.innerWidth - 30; 
//       this.WEBCAM_NEW_HEIGHT = selectedTrack.height * (this.WEBCAM_NEW_WIDTH / selectedTrack.width)

//       let coeff = 1;
//       for (coeff = 1; this.WEBCAM_NEW_WIDTH * coeff < 1000; coeff++);
//       this.WEBCAM_NEW_HEIGHT *= coeff;
//       this.WEBCAM_NEW_WIDTH *= coeff;

//     } catch (e) {
//       if (e.name !== 'OverconstrainedError') {
//         NotificationManager.handleError(e.message, this.snackBar);
//       } else {
//         NotificationManager.handleWarning(`Paramètre caméra non supportés: ${e.constraint}`, this.snackBar);
//       }
//     }
//   }

//   stop() {
//     this.stream.getTracks().forEach((track) => {
//       track.stop();
//     });
//   }

//   switchCamera() {
//     const idx = this.devices.findIndex(x => x.deviceId === this.selectedDevice);
//     let isSet = false;
//     for (let i = idx + 1; !isSet; i++) {
//       if (i === this.devices.length) {
//         i = 0;
//       }
//       if (this.devices[i].kind === 'videoinput') {
//         this.selectedDevice = this.devices[i].deviceId;
//         isSet = true;
//         this.play();
//       }
//     }
//   }

//   hasMultipleCam() {
//     return this.devices.filter(d => d.kind === 'videoinput')?.length > 1;
//   }

//   capture() {
//     var context = this.canvas.nativeElement.getContext('2d').drawImage(this.video.nativeElement, 0, 0, this.WEBCAM_NEW_WIDTH, this.WEBCAM_NEW_HEIGHT);
//     this.isCaptured = true;
//     this.SelectedCapture = this.canvas.nativeElement.toDataURL('image/png');
//     this.pictureService.updateImage(this.SelectedCapture);
//   }

//   deleteCapture() {
//     this.SelectedCapture = null;
//     this.isCaptured = false;
//   }

//   validatePhoto() {
//     this.router.navigate([ENavigationRoute.Photo, {interventionCode: this.interventionCode, alreadyPicked: this.alreadyPicked.map(x => x) }], { replaceUrl: true });
//   }

//   drawImageToCanvas(image: any) {
//     this.canvas.nativeElement
//       .getContext('2d')
//       .drawImage(image, 0, 0, this.WEBCAM_DISPLAY_WIDTH, this.WEBCAM_DISPLAY_HEIGHT);
//   }
// }
